export default {
  menu: {
    add: 'agregar',
    history: 'historial',
    data: 'datos',
    greeting: 'hola',
    logout: 'salir',
    notLoggued: 'no registrado',
    color: 'color',
    article: 'artículo',
    order: 'orden',
    design: 'diseño',
    method: 'método',
    code: 'código',
    conveyor: 'transportadora',
    location: 'ubicación',
    delivery: 'entrega',
    refund: 'reembolso',
    invoice: 'factura',
    price: 'precio',
    articleDefault: 'artículo pred.',
    size: 'talla',
    user: 'usuario',
    product: 'producto',
    label: 'etiqueta',
    labels: 'etiquetas',
    returnAddress: 'remite',
    remission: 'remision',
    tier: 'nivel',
    temporaryStock: 'inventario temp.',
    orderWholesaler: 'orden mayorista',
    print: 'imprimir',
    login: 'entrar',
    verification: 'verificación',
    connected: 'conectado',
    notConnected: 'no conectado'
  },
  order: {
    fields: {
      isWholesaler: 'mayorista',
      isDropshipping: 'dropshipping',
      dni: 'cédula',
      name: 'nombre',
      phone: 'teléfono',
      email: 'email',
      location: 'ciudad o municipio',
      department: 'departamento',
      address: 'dirección',
      deliveryTime: 'tiempo de entrega',
      conveyor: 'transportadora',
      conveyorCost: 'costo de la transportadora',
      methodPay: 'método de pago',
      methodPayCost: 'costo del método de pago',
      adviser: 'asesor',
      mpCode: 'código en mi paquete',
      tip: 'propina',
      codeName: 'código promocional',
      codePercent: 'porcentaje de descuento',
      codeValue: 'valor de descuento'
    },
    titles: {
      generalData: 'datos generales',
      products: 'productos',
      observations: 'observaciones',
      pay: 'pagos',
      history: 'historial'
    },
    subtitles: {
      total: 'total',
      manuals: 'manuales'
    },
    labels: {
      typeProduct: 'escribe un producto',
      observation: 'observación',
      type: 'tipo',
      methodPay: 'método de pago',
      value: 'valor'
    },
    buttons: {
      findProduct: 'buscar producto',
      addObservation: 'agragar observación',
      check: 'revisar',
      decline: 'rechazar',
      approve: 'aprobar',
      addPay: 'agregar pago',
      update: 'actualizar',
      save: 'guardar'
    },
    tables: {
      observation: 'observación',
      type: 'type',
      methodPay: 'método de pago',
      state: 'estado',
      value: 'valor',
      createdAt: 'creado',
      checkedAt: 'revisado',
      actions: 'acciones',
      createdBy: 'creado por',
      updatedBy: 'actualizó',
      updatedAt: 'actualizado',
      declined: 'rechazado',
      approved: 'aprobado',
      paid: 'pagado',
      packed: 'empacado',
      sent: 'enviado',
      refunded: 'reembolsado',
      delivery: 'entrega',
      conveyor: 'transportadora',
      tracking: 'guía'
    },
    options: {
      delivery: 'entrega',
      pay: 'pagos',
      product: 'producto',
      support: 'soporte'
    },
    states: {
      created: 'creado',
      approved: 'aprobado',
      declined: 'rechazado',
      delivered: 'entregado',
      inprogress: 'en progreso',
      refunded: 'reembolsado'
    }
  }
}



// WEBPACK FOOTER //
// ./src/languages/spanish.js